var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"col-12 text-left"},[_c('div',{staticClass:"text-widget",domProps:{"innerHTML":_vm._s(_vm.markdown)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }